import type { ITenantResponse, IUpdateTenant, IMemberResponse, IUpdateMemberRole } from '@escloud/types';

import type { ApiClient } from './api-client';

export class TenantsService {
    constructor(private api: ApiClient) {}

    getCurrentTenant(): Promise<ITenantResponse> {
        return this.api.get<ITenantResponse>('/tenants/current');
    }

    updateCurrentTenant(data: IUpdateTenant): Promise<ITenantResponse> {
        return this.api.patch<ITenantResponse>('/tenants/current', data);
    }

    getMembers(tenantId: string): Promise<{ items: IMemberResponse[] }> {
        return this.api.get<{ items: IMemberResponse[] }>(`/tenants/${tenantId}/members`);
    }

    updateMemberRole(tenantId: string, userId: string, data: IUpdateMemberRole): Promise<IMemberResponse> {
        return this.api.patch<IMemberResponse>(`/tenants/${tenantId}/members/${userId}`, data);
    }

    removeMember(tenantId: string, userId: string): Promise<void> {
        return this.api.delete<void>(`/tenants/${tenantId}/members/${userId}`);
    }
}
